var _rect, _g, _g2, _g3, _g4, _path, _path2, _g5, _g6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 982,
    viewBox: "0 0 1512 982",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -8.53711,
    y: -17.4258,
    width: 2545.64,
    height: 1670.36,
    fill: "url(#paint0_linear_2375_6753)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2375_6753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1164.41 408.915C1052.69 303.743 905.734 245.046 752.721 244.476C599.709 243.906 451.823 301.505 338.423 405.839C225.022 510.173 154.398 653.613 140.57 807.684C126.742 961.755 170.721 1115.19 263.777 1237.54L747.778 860.652L1164.41 408.915Z",
    fill: "url(#paint1_linear_2375_6753)",
    fillOpacity: 0.62
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2375_6753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M756.106 862.084C830.964 937.713 931.358 982.014 1037.36 986.191C1143.36 990.367 1247.22 954.115 1328.31 884.631C1409.41 815.146 1461.81 717.51 1475.13 611.104C1488.44 504.697 1461.68 397.302 1400.17 310.236L1055.71 559.396L756.106 862.084Z",
    fill: "url(#paint2_linear_2375_6753)",
    fillOpacity: 0.62
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2375_6753)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 533.001,
    ry: 531.883,
    transform: "matrix(-0.780342 -0.625353 0.617529 -0.786548 2138.62 650.666)",
    fill: "url(#paint3_linear_2375_6753)",
    fillOpacity: 0.62
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_2375_6753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.0703 1308.49C37.7651 1341.83 1.28652 1408 -12.7437 1437.76L-37.998 1538.12L1.56713 1767.75C5.21498 1769.74 23.4542 1740.03 67.2285 1605.31C121.946 1436.91 558.847 1199.63 629.559 1150.3C706.305 1096.76 870.317 942.779 899.781 912.162C929.244 881.544 1059.35 722.77 1194.42 600.882C1344.26 465.654 1515.99 399.316 1609.43 382.306C1698.88 366.023 1816.51 361.044 1903.22 372.951C1982.9 383.893 2234.89 440.14 2317.39 455.449C2383.39 467.696 2505.68 476.994 2558.15 480.963L2564.04 -44.6402C2218.34 -46.0577 1528.11 -44.8095 1485.68 -25.0781C1432.65 -0.413933 1334.45 80.7587 1286.17 133.963C1239.87 184.993 989.855 521.788 962.917 556.657C938.044 588.852 761.724 837.319 687.644 902.806C615.486 966.596 412.371 1089.91 371.123 1108.62C330.479 1127.06 215.387 1191.12 187.608 1208.98C159.828 1226.84 105.952 1266.82 68.0703 1308.49Z",
    fill: "url(#paint4_linear_2375_6753)",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2375_6753",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -39,
    y: -46,
    width: 2604,
    height: 1814
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.0644 1308.49C37.7592 1341.83 1.28066 1408 -12.7495 1437.76L-38.0039 1538.12L1.56127 1767.75C5.20912 1769.74 23.4484 1740.03 67.2226 1605.31C121.94 1436.91 558.841 1199.63 629.553 1150.3C706.299 1096.76 870.311 942.779 899.775 912.162C929.238 881.544 1059.35 722.77 1194.41 600.882C1344.25 465.654 1515.98 399.316 1609.42 382.306C1698.87 366.023 1816.51 361.044 1903.21 372.951C1982.9 383.893 2234.89 440.14 2317.39 455.449C2383.38 467.696 2505.67 476.994 2558.15 480.963L2564.04 -44.6402C2218.33 -46.0577 1528.1 -44.8095 1485.68 -25.0781C1432.64 -0.413933 1334.44 80.7587 1286.17 133.963C1239.87 184.993 989.849 521.788 962.911 556.657C938.038 588.852 761.718 837.319 687.638 902.806C615.48 966.596 412.366 1089.91 371.117 1108.62C330.473 1127.06 215.382 1191.12 187.602 1208.98C159.822 1226.84 105.946 1266.82 68.0644 1308.49Z",
    fill: "url(#paint5_linear_2375_6753)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0644 1308.49C37.7592 1341.83 1.28066 1408 -12.7495 1437.76L-38.0039 1538.12L1.56127 1767.75C5.20912 1769.74 23.4484 1740.03 67.2226 1605.31C121.94 1436.91 558.841 1199.63 629.553 1150.3C706.299 1096.76 870.311 942.779 899.775 912.162C929.238 881.544 1059.35 722.77 1194.41 600.882C1344.25 465.654 1515.98 399.316 1609.42 382.306C1698.87 366.023 1816.51 361.044 1903.21 372.951C1982.9 383.893 2234.89 440.14 2317.39 455.449C2383.38 467.696 2505.67 476.994 2558.15 480.963L2564.04 -44.6402C2218.33 -46.0577 1528.1 -44.8095 1485.68 -25.0781C1432.64 -0.413933 1334.44 80.7587 1286.17 133.963C1239.87 184.993 989.849 521.788 962.911 556.657C938.038 588.852 761.718 837.319 687.638 902.806C615.48 966.596 412.366 1089.91 371.117 1108.62C330.473 1127.06 215.382 1191.12 187.602 1208.98C159.822 1226.84 105.946 1266.82 68.0644 1308.49Z",
    fill: "url(#paint6_radial_2375_6753)",
    fillOpacity: 0.2
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2375_6753)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_2375_6753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2136.27 652.385C2104.02 524.299 2021.71 408.4 1906.16 328.348C1790.61 248.295 1650.52 210.125 1514.5 221.63C1378.47 233.135 1256.77 293.447 1174.22 390.254C1091.68 487.061 1054.53 613.063 1070.34 742.538L1609.02 728.056L2136.27 652.385Z",
    fill: "url(#paint7_linear_2375_6753)",
    fillOpacity: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_2375_6753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M982.593 905.634C923.315 851.308 843.393 820.733 759.141 820.151C674.89 819.568 592.661 849.023 529.243 902.501C465.824 955.979 425.997 1029.45 417.892 1107.91C409.787 1186.37 434.015 1263.91 485.63 1324.7L747.284 1128.84L982.593 905.634Z",
    fill: "url(#paint8_linear_2375_6753)",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.593 905.634C923.315 851.308 843.393 820.733 759.141 820.151C674.89 819.568 592.661 849.023 529.243 902.501C465.824 955.979 425.997 1029.45 417.892 1107.91C409.787 1186.37 434.015 1263.91 485.63 1324.7L747.284 1128.84L982.593 905.634Z",
    fill: "url(#paint9_linear_2375_6753)",
    fillOpacity: 0.9
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_2375_6753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1203.26 1680.98C1203.06 1603.79 1187.76 1527.42 1158.22 1456.22C1128.68 1385.02 1085.49 1320.39 1031.1 1266.02C976.708 1211.65 912.193 1168.61 841.235 1139.35C770.277 1110.08 694.265 1095.18 617.541 1095.48C540.816 1095.78 464.88 1111.27 394.07 1141.09C323.259 1170.91 258.96 1214.45 204.843 1269.25C150.727 1324.04 107.853 1389 78.6694 1460.43C49.486 1531.86 34.5646 1608.35 34.7572 1685.54L619.007 1683.26L1203.26 1680.98Z",
    fill: "url(#paint10_linear_2375_6753)",
    fillOpacity: 0.62
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2375_6753",
    x: -22.9258,
    y: 83.4727,
    width: 1348.33,
    height: 1315.06,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 80.5,
    result: "effect1_foregroundBlur_2375_6753"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2375_6753",
    x: 595.105,
    y: 149.236,
    width: 1044.36,
    height: 998.279,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 80.5,
    result: "effect1_foregroundBlur_2375_6753"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2375_6753",
    x: 1447.62,
    y: -45.2539,
    width: 1381.99,
    height: 1391.84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 80.5,
    result: "effect1_foregroundBlur_2375_6753"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2375_6753",
    x: -40.998,
    y: -48.0547,
    width: 2608.04,
    height: 1818.9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_2375_6753"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_2375_6753",
    x: 939.777,
    y: 92.6191,
    width: 1323.49,
    height: 776.919,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 63.5,
    result: "effect1_foregroundBlur_2375_6753"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_2375_6753",
    x: 289.357,
    y: 693.143,
    width: 820.236,
    height: 758.559,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 63.5,
    result: "effect1_foregroundBlur_2375_6753"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_2375_6753",
    x: -126.244,
    y: 934.472,
    width: 1490.5,
    height: 912.069,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 80.5,
    result: "effect1_foregroundBlur_2375_6753"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2375_6753",
    x1: -8.53711,
    y1: -17.4258,
    x2: 2552.53,
    y2: 1628.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#D0D6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2375_6753",
    x1: 1060.56,
    y1: 1086.51,
    x2: 35.899,
    y2: 626.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2375_6753",
    x1: 844.46,
    y1: 395.178,
    x2: 1543.42,
    y2: 738.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2375_6753",
    x1: 538.104,
    y1: 744.664,
    x2: 280.324,
    y2: -161.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "#C8C2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2375_6753",
    x1: 2564.04,
    y1: -44.6393,
    x2: -52.5527,
    y2: 1609.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2375_6753",
    x1: 2564.04,
    y1: -44.6393,
    x2: -52.5585,
    y2: 1609.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150077"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2375_6753",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1263.02 861.395) rotate(90) scale(906.45 1301.02)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B4CDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2375_6753",
    x1: 1579.96,
    y1: 835.619,
    x2: 1114.03,
    y2: 268.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802083,
    stopColor: "#CCC5EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#BBB0F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2375_6753",
    x1: 666.236,
    y1: 1103.82,
    x2: 342.643,
    y2: 1073.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8860E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802083,
    stopColor: "#2A09CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#330EEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2375_6753",
    x1: 666.236,
    y1: 1103.82,
    x2: 108.826,
    y2: 1074.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492248,
    stopColor: "#C5DBF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#CDECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2375_6753",
    x1: 1287.85,
    y1: 1184.32,
    x2: 443.968,
    y2: 1676.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F8FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLight);
export default __webpack_public_path__ + "static/media/bgLight.939e0570e5097c8ec8c01148f9617a80.svg";
export { ForwardRef as ReactComponent };